<template>
  <div>
    <zj-layout-container
      v-loading="loading"
      element-loading-text="加载中..."
    >
      <zj-layout-header>
        <div class="listtitle">Wifi数据分析</div>
        <el-form
          class="zj-search-form"
          ref="queryForm"
          :model="queryParams"
          :label-width="labelWidth"
        >
          <el-form-item label="时间" prop="timeRange">
              <el-date-picker
                v-model="time"
                type="date"
                :clearable="false">
              </el-date-picker>
          </el-form-item>
          <el-form-item label="设备名称" prop="wifiType">
             <el-select
                  v-model="queryParams.wifiType"
                  placeholder="请选择"
                  clearable
                >
                  <el-option
                    v-for="item in list"
                    :key="item.equipmentName"
                    :label="item.equipmentName"
                    :value="item.equipmentName"
                  ></el-option>
                </el-select>
          </el-form-item>
          
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="ecahrts-wrap">
          <div class="ecahrts-up">
               <linechart
                title="用户数量"
                xAxisName=""
                yAxisName=""
                :chartData="usePerData"
                className="echart-01"
              ></linechart>
          </div>
          <div class="echart-down">
               <barchart
                title="WIFI设备实时连接总数"
                xAxisName=""
                yAxisName=""
                :chartData="connentData"
              ></barchart>
          </div>
        </div>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>

<script>
import { getEquipmentCode, listEquipment } from "@/api/src/equipment";
import { getWifiUsrCount } from "@/api/src/equipmentDataStat";
import moment from 'moment';
import ZJApp from '../../../../app';
const utils = ZJApp.ZJUtils;
export default {
  name: "Wifi",
  controller: "UI",
  action: "Wifi",
  components: {
  },
  data() {
    return {
      // 设备类型categoryCode
      categoryCode: '',
      // 遮罩层
      loading: false,
      time:'',
      // 设备列表
      list: [],
      queryParams:{
        wifiType:'',
        startTime:'',
        endTime:'',
      },
      usePerData:{
        days:[],
        data:[]
      },
      connentData:{
        days:[],
        data:[]
      },
    };
  },
  watch:{
    time(newVal){
      this.queryParams.startTime = moment(newVal).format('YYYY-MM-DD 00:00:00')
      this.queryParams.endTime = moment(newVal).format('YYYY-MM-DD 23:59:59')
    },
  },
  created: function() {
    this.$nextTick(()=>{
      this.init();
    });
  },
  methods: {
    // 获取设备categoryCode
    init(){
      this.resetDate()
      getEquipmentCode('wifiEquipment').then(response =>{
        this.categoryCode = response.data;
        this.onSearch();
      });
    },
    resetDate(){
      this.time = moment().format('YYYY-MM-DD')
    },
   // 点击清理按钮
    onCancel() {
      this.resetForm("queryForm");
      this.resetDate()
      this.onSearch();
    },
    onSearch(){
      this.loading = true;
       let { categoryCode, queryParams } = this
      utils.waitAll([
        getWifiUsrCount(queryParams), 
        listEquipment({
        page:1,
        size:1000,
        categoryCode,
        equipmentName:queryParams.wifiType
        })
      ])
      .then(res => {
        this.loading = false;
        let days = [],data = []
        res[0].data&&res[0].data.map(item =>{
          days.push( moment(item.time ).format('HH:00'))
          data.push( Number(item.val) )
        })
        this.usePerData = { days, data }

        let days2 = [],data2 = []
        res[1].rows.map(item =>{
          days2.push( item.equipmentName )
          data2.push( item.wifiUsr )
        })
        this.connentData = { days:days2, data:data2 }
        if(!queryParams.wifiType){
          this.list = res[1].rows;
        }
      }).catch((res =>{
        this.loading = false;
      }))
    }
  },
};
</script>
<style scoped lang="scss">
.ecahrts-wrap {
  position: relative;
  width: 100%;
  height: 100%;
}
.ecahrts-up,
.echart-down {
  width: 100%;
  height: 48%;
}
.echart-down{
  margin-top: 15px;
}
</style>
